import { Box, Typography } from '@mui/material';

const StepCircle = (props: { number: number }) => {
  return (
    <Box
      sx={{
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'transparent',
        border: '1.5px solid #515555',
        flexShrink: 0,
        transition: 'all 0.3s ease',
      }}
    >
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 500,
          color: '#515555',
          lineHeight: '20px',
        }}
      >
        {props.number}
      </Typography>
    </Box>
  );
};

export default StepCircle;
